import React, { useState, useEffect } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { getOwnerDetails, updateOwnerProfile } from '../actions/ownerActions.js'
import { OWNER_UPDATE_PROFILE_RESET } from '../constants/ownerConstants.js'

// OwnerProfileScreen component
const OwnerProfileScreen = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const ownerDetails = useSelector((state) => state.ownerDetails)
  const { loading, error, owner } = ownerDetails

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const ownerUpdateProfile = useSelector((state) => state.ownerUpdateProfile)
  const { success } = ownerUpdateProfile

  useEffect(() => {
    if (!ownerInfo) {
      navigate('/ownerlogin')
    } else {
      if (!owner || !owner.name || success) {
        dispatch({ type: OWNER_UPDATE_PROFILE_RESET })
        dispatch(getOwnerDetails(ownerInfo._id))
      }
    }
  }, [dispatch, navigate, ownerInfo, owner, success])

  const submitHandler = (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      dispatch(updateOwnerProfile({ id: owner._id, password }))
      setMessage('Password updated successfully')
      setPassword('')
      setConfirmPassword('')
    }
  }

  return (
    <Row>
      <Col md={4}>
        <h2>Owner Profile</h2>
        {message && <Message variant='danger'>{message}</Message>}
        {success && <Message variant='success'>Profile Updated</Message>}
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='bname'>
              <Form.Label>Business Name</Form.Label>
              <Form.Control readOnly type='text' value={owner.bname || ''} />
            </Form.Group>
            <Form.Group controlId='name'>
              <Form.Label>Name</Form.Label>
              <Form.Control readOnly type='name' value={owner.name || ''} />
            </Form.Group>

            <Form.Group controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                readOnly
                type='email'
                placeholder='Enter email'
                value={owner.email || ''}
              />
            </Form.Group>

            <Form.Group controlId='password'>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='Enter password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId='confirmPassword'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type='confirmpassword'
                placeholder='Confirm password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            <br />
            <Button type='submit' variant='primary'>
              Update Password
            </Button>
          </Form>
        )}
      </Col>
      <Col md={8}>
        <h2>Private Keys</h2>
        <Form>
          <Form.Group controlId='apikey'>
            <Form.Label>API Key</Form.Label>
            <Form.Control
              type='text'
              placeholder='API Key'
              value={owner.apiKey || ''}
              readOnly
            />
          </Form.Group>
          <Form.Group controlId='cid'>
            <Form.Label>Customer ID</Form.Label>
            <Form.Control
              type='text'
              placeholder='Customer ID'
              value={owner.cid || ''}
              readOnly
            />
          </Form.Group>
        </Form>
      </Col>
    </Row>
  )
}

export default OwnerProfileScreen
